import React from "react"
import {
  VictoryChart,
  VictoryGroup,
  VictoryBar,
  VictoryAxis,
  VictoryLabel,
  VictoryLegend,
} from "victory"
import {
  GraphContainer,
  GraphDisclaimerContainer,
  GraphDisclaimerText,
  GraphWrapper,
} from "../../UIKit/styles"
import { theme } from "../../UIKit"
import { GRAPH_DISCLAIMER_TEXT } from "../../constants"

function BarGraph({ data, yLabel, colorScale, legendLabels, hideDisclaimer=false }) {
  const getMaxYValue = () => {
    const maxY = Math.max(...[].concat(...data).map((item) => item.y))
    if (maxY / 1000 > 1) return maxY + 500
    return maxY + 100
  }

  const getLegend = () => {
    return legendLabels.map((label, i) => ({
      name: label,
      symbol: {
        fill: colorScale[i],
        type: "square",
      },
    }))
  }
  return (
    <GraphWrapper>
      <GraphContainer>
          {!hideDisclaimer && (
            <GraphDisclaimerContainer>
              <GraphDisclaimerText>{GRAPH_DISCLAIMER_TEXT}</GraphDisclaimerText>
            </GraphDisclaimerContainer>
          )}
        <VictoryChart
          width={700}
          height={350}
          maxDomain={{
            y: getMaxYValue(),
          }}
          style={{
            background: {
              fill: theme.lightGrey,
              stroke: "#000000",
            },
          }}
        >
          <VictoryLegend
            data={getLegend()}
            x={350}
            y={55}
            orientation="horizontal"
            gutter={20}
            style={{
              labels: {
                fontSize: 12,
              },
            }}
          />
          <VictoryAxis
            data-testid="graph-y-axix"
            dependentAxis
            label={yLabel}
            style={{
              axisLabel: {
                fontSize: 12,
                padding: 50,
              },
              tickLabels: {
                fontSize: 12,
              },
              grid: { stroke: theme.darkGrey },
            }}
          />
          <VictoryAxis
            tickLabelComponent={
              <VictoryLabel
                textAnchor="end"
                angle={-45}
                transform={"translate(-5, -7)"}
                style={{
                  padding: 0,
                  fontSize: 12,
                }}
              />
            }
          />
          <VictoryGroup
            colorScale={colorScale}
            offset={10}
            style={{
              data: {
                width: 5,
              },
            }}
          >
            {data.map((item, i) => (
              <VictoryBar
                data={item}
                key={`data-${i}`}
                data-testid="graph-bar"
              />
            ))}
          </VictoryGroup>
        </VictoryChart>
      </GraphContainer>
    </GraphWrapper>
  )
}

export default BarGraph
